// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__4NMUz","dragIcon":"Choice_dragIcon__gFH5h","left":"Choice_left__2Jj1G","input":"Choice_input__1zK67"};